const CHANNEL_NAME = 'sip-mailer-microsoft-oauth';
const STORAGE_KEY = 'sip-mailer-microsoft-oauth';
const MESSAGE_TYPE = 'sip-mailer-microsoft-oauth';
const MAX_AGE_MS = 2 * 60 * 1000;

export const MICROSOFT_OAUTH_POPUP_NAME = 'sipMicrosoftOAuth';
export const MICROSOFT_OAUTH_POPUP_FEATURES =
    'width=500,height=720,menubar=no,toolbar=no,status=no';

const readOAuthReturnFromUrl = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    const params = new URLSearchParams(window.location.search);
    const oauth = params.get('oauth');

    if (oauth !== 'success' && oauth !== 'error') {
        return null;
    }

    const provider = params.get('provider');
    if (provider && provider !== 'microsoft') {
        return null;
    }

    return {
        type: MESSAGE_TYPE,
        oauth,
        provider: provider || 'microsoft',
        message: params.get('message') || '',
        ts: Date.now(),
    };
};

export const isMicrosoftOAuthReturn = (payload) => {
    if (!payload || payload.type !== MESSAGE_TYPE) {
        return false;
    }

    if (payload.oauth !== 'success' && payload.oauth !== 'error') {
        return false;
    }

    if (payload.provider && payload.provider !== 'microsoft') {
        return false;
    }

    if (payload.ts && Date.now() - payload.ts > MAX_AGE_MS) {
        return false;
    }

    return true;
};

export const publishMicrosoftOAuthReturn = (payload) => {
    if (!payload) {
        return;
    }

    const data = {
        ...payload,
        type: MESSAGE_TYPE,
        ts: payload.ts || Date.now(),
    };

    try {
        const channel = new BroadcastChannel(CHANNEL_NAME);
        channel.postMessage(data);
        channel.close();
    } catch (error) {
        // BroadcastChannel is unavailable in some browsers.
    }

    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
        // Ignore quota / private-mode failures.
    }
};

export const subscribeMicrosoftOAuthReturn = (onResult) => {
    let channel;

    const handlePayload = (payload) => {
        if (!isMicrosoftOAuthReturn(payload)) {
            return;
        }

        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
            // Ignore.
        }

        onResult(payload);
    };

    try {
        channel = new BroadcastChannel(CHANNEL_NAME);
        channel.onmessage = (event) => handlePayload(event.data);
    } catch (error) {
        channel = null;
    }

    const onStorage = (event) => {
        if (event.key !== STORAGE_KEY || !event.newValue) {
            return;
        }

        try {
            handlePayload(JSON.parse(event.newValue));
        } catch (error) {
            // Ignore malformed values.
        }
    };

    window.addEventListener('storage', onStorage);

    return () => {
        window.removeEventListener('storage', onStorage);
        if (channel) {
            channel.close();
        }
    };
};

export const closeIfMicrosoftOAuthPopup = () => {
    const payload = readOAuthReturnFromUrl();

    if (!payload) {
        return false;
    }

    const isPopup =
        window.name === MICROSOFT_OAUTH_POPUP_NAME ||
        (!!window.opener && !window.opener.closed);

    if (!isPopup) {
        return false;
    }

    publishMicrosoftOAuthReturn(payload);

    try {
        window.close();
    } catch (error) {
        // Some browsers ignore window.close() without an opener.
    }

    if (!window.closed) {
        window.location.replace('about:blank');
    }

    return true;
};

closeIfMicrosoftOAuthPopup();
